export const getTotalPreTax = (state) => state.receipt.totalPreTax

export const getTaxCost = (state) => state.receipt.taxCost

export const getTipCost = (state) => state.receipt.tipCost

export const getItems = (state) => [...state.receipt.items]



/** WEBPACK FOOTER **
 ** ./src/core/receipt/selectors.js
 **/